export default {
    data() {
        return {
            url: this.$serverURL + this.$api.cms.exclusiveBrandPage.exclusiveBrandSectionThreeCMS,
            cmsData: {},
            preview: {
                brandImage: "",
                productImageOne: "",
                productImageTwo: "",
                productImageThree: "",
            }
        }
    },
    async created() {
        document.title = "Dispo - Exclusive Brand Section Three CMS";
        this.getData();

    },
    methods: {
        async getData() {
            let response = await this.getCmsData(this.url);
            if (response.statusCode == 200) {
                this.cmsData = (response.data.length > 0) ? response.data[0] : {};
            }
            else {
                this.cmsData = {};
            }
        },
        handleUploadImage(imageKey, previewImageKey, ref, event) {
            this.cmsData[imageKey] = event.target.files[0];
            let input = this.$refs[ref];
            let file = input.files;
            if (file && file[0]) {
                let reader = new FileReader
                reader.onload = e => {
                    this.preview[previewImageKey] = e.target.result
                }
                reader.readAsDataURL(file[0])
            }
        },
        async updateCms() {
            try {
                let fromData = new FormData();
                fromData.append('title', this.cmsData.title);
                fromData.append('brandImageLink', this.cmsData.brandImageLink);
                fromData.append('productImageOneLink', this.cmsData.productImageOneLink);
                fromData.append('productImageTwoLink', this.cmsData.productImageTwoLink);
                fromData.append('productImageThreeLink', this.cmsData.productImageThreeLink);
                fromData.append('brandImage', this.cmsData.brandImage);
                fromData.append('productImageOne', this.cmsData.productImageOne);
                fromData.append('productImageTwo', this.cmsData.productImageTwo);
                fromData.append('productImageThree', this.cmsData.productImageThree);
                this.$swal.showLoading();
                let response = await this.createUpdateCMS(this.url, fromData);
                if (response.statusCode == 200 || response.statusCode == 201) {
                    this.$refs.brandImage.value = null;
                    this.$refs.productImageOne.value = null;
                    this.$refs.productImageTwo.value = null;
                    this.$refs.productImageThree.value = null;
                    this.preview = {
                        brandImage: "",
                        productImageOne: "",
                        productImageTwo: "",
                        productImageThree: "",
                    }
                    this.$swal.fire({
                        toast: true,
                        position: 'top-end',
                        text: response.message,
                        icon: "success",
                        showConfirmButton: false,
                        timer: 3000,
                        animation: false,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', this.$swal.stopTimer)
                            toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                        }
                    });
                }
                await this.getData();
            } catch (error) {
                this.$swal.fire({
                    icon: "error",
                    text: "Something went wrong. Please try again!"
                });
            } finally {
                this.$swal.hideLoading();
            }
        }
    }
}